import { Component, OnInit } from '@angular/core';
import { TransactionListModel } from 'Model';
import { UtilserviceService } from 'app/services/utilservice.service';
import { environment } from 'environments/environment';

declare interface TableData {
    headerRow: string[];
    //dataRows: string[][];
    dataRows: Array<TransactionListModel>
}

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.css']
})
export class TransactionComponent implements OnInit {
  public tableData1: TableData;
  constructor(private util: UtilserviceService) { }

  async ngOnInit() {
    let table =  await this.util.getTransactionList();
    console.log('table', table);
    
      this.tableData1 = {
          headerRow: ['Date', 'Attempts Added', 'Attempts Used', 'Attempts Remaining', 'Expiry', 'Expiry Status'],
          dataRows: table
      };          
  }

}
